import { Search } from '@com-delta-omnichannel/mach-core-js';

export class AirportDropdownModalExtendedComponent {
  searchInstance!: Search;
  clearSearch(event: MouseEvent) {
    const target = event.target as HTMLElement;
    if (target.classList.contains('mask-icon')) {
      event.stopPropagation();
      event.preventDefault();
      this.searchInstance.clearSearch();
      this.searchInstance.hide();
    }
  }

  handleShiftTab(
    activeElement: Element | null,
    firstElement: HTMLElement,
    lastElement: HTMLElement,
    event: KeyboardEvent
  ): void {
    if (activeElement === firstElement) {
      event.preventDefault();
      lastElement.focus();
    }
  }
}
